import { create } from 'zustand'
import { themeNames } from '~/styles/colors'

type Store = {
  isNavOpened: boolean
  setIsNavOpened: (value: boolean) => void
  theme: Theme | null
  setTheme: (value: Theme | null) => void
  isFooterFullyInView: boolean
  setIsFooterFullyInView: (value: boolean) => void
  hasAppeared: boolean
  setHasAppeared: (value: boolean) => void
}

type Theme = (typeof themeNames)[number]

export const useStore = create<Store>((set) => ({
  isNavOpened: false,
  setIsNavOpened: (value: boolean) => set({ isNavOpened: value }),
  theme: null,
  setTheme: (value: Theme | null) => {
    if (value === null || themeNames.includes(value)) {
      set({ theme: value })
    }
  },
  isFooterFullyInView: false,
  setIsFooterFullyInView: (value: boolean) =>
    set({ isFooterFullyInView: value }),
  hasAppeared: false,
  setHasAppeared: (value: boolean) => set({ hasAppeared: value }),
}))
